<template>
  <div>
    <!-- Button: 單筆更新實收 -->
    <a-button
      :disabled="disabled"
      type="primary"
      size="small"
      @click="handleOpenModal(data)"
    >
      {{ $t('i18n_single_actual_coin_update') }}
    </a-button>
    <!-- Modal: 單筆更新實收 -->
    <a-modal
      v-model="modalVisible"
      :mask-closable="false"
      :closable="false"
      :title="$t('i18n_single_actual_coin_update')"
      on-ok="handleOk"
      class="ant-modal-confirm-error custom-error-modal"
    >
      <a-form-model
        ref="ruleForm"
        class="ignore"
        :model="form"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        :rules="rules"
      >
        <!-- Text: 訂單建立時間 (僅供顯示) -->
        <a-form-model-item
          ref="created_at"
          :label="$t('i18n_order_create_time')"
          prop="created_at"
        >
          <div>
            {{ form.created_at | timestampFormat }}
          </div>
        </a-form-model-item>
        <!-- Text: 項目組 (僅供顯示) -->
        <a-form-model-item
          ref="section"
          :label="$t('i18n_section')"
          prop="section"
        >
          <div>
            {{ form.section || '-' }}
          </div>
        </a-form-model-item>
        <!-- Text: 收幣地址 (僅供顯示) -->
        <a-form-model-item
          ref="address"
          :label="$t('i18n_rec_address')"
          prop="address"
        >
          <div>
            {{ form.address || '-' }}
          </div>
        </a-form-model-item>
        <!-- InputNumber: 實收幣數 -->
        <a-form-model-item
          ref="actual_coins"
          :label="$t('i18n_actual_money')"
          prop="actual_coins"
        >
          <a-input-number
            v-model="form.actual_coins"
            :placeholder="
              $t('i18n_rule_required_field', {
                field: $t('i18n_actual_money')
              })
            "
            :min="0.0"
            :max="999999999.99999999"
            :precision="8"
            :step="0.00000001"
            :formatter="val => commaFormater(val, 8)"
            style="width: 100%"
          />
        </a-form-model-item>
      </a-form-model>

      <!-- Modal-Footer -->
      <template slot="footer">
        <div class="text-align--center">
          <!-- Button: 取消 -->
          <a-button
            class="ant-btn"
            :disabled="isLoading"
            @click="handleCloseModal"
          >
            <span>{{ $t('i18n_cancel') }}</span>
          </a-button>
          <!-- Button: 確定 -->
          <a-button
            :disabled="isLoading"
            class="ant-btn-primary"
            @click="handleSubmit"
          >
            <span>{{ $t('i18n_confirm') }}</span>
          </a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { priceFormat, timestampFormat } from '@G/filters'
import InputsProps from '@G/mixins/InputsProps'
import { deepCopy } from '@GUTIL/other'
import { infoModal, errorModal } from '@GUTIL/prompt'

const defaultForm = {
  // 訂單建立時間
  created_at: '',
  // 項目組
  section: '',
  // 收幣地址
  address: '',
  // 實收幣數
  actual_coins: ''
}

export default {
  name: 'ManualUpdateModal',
  filters: {
    priceFormat,
    timestampFormat
  },
  mixins: [InputsProps],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // Form data
      form: deepCopy(defaultForm),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      customerServicesList: [],
      rules: {
        actual_amount: [
          {
            pattern: /\B(?=(\d{3})+(?!\d))/g,
            message: this.$t('i18n_rule_required_field_correct', {
              field: this.$t('i18n_audit_amount_ten_thousand')
            })
          }
        ]
      },
      // Modal data
      modalVisible: false,
      isLoading: false
    }
  },
  methods: {
    // 開啟彈窗
    async handleOpenModal(data) {
      this.modalVisible = true
      this.form = {
        // 訂單建立時間
        created_at: data.receive_order.created_at,
        // 項目組
        section: data.section.name,
        // 收幣地址
        address: data.address.addr,
        // 實收幣數
        actual_coins: data.address.actual_coins
      }
    },
    // 關閉彈窗
    handleCloseModal() {
      this.modalVisible = false
    },
    // [單筆更新實收] 參數預處理
    getUpdateActualCoinArgs() {
      let isFormValid = false
      this.$refs.ruleForm.validate(
        valid => (isFormValid = valid ? true : false)
      )

      if (isFormValid) {
        return {
          in: {
            // 收幣地址
            address: this.form.address,
            // 實收幣數
            actual_coins: this.form.actual_coins.toString(),
            // 訂單建立時間
            order_created_at: this.form.created_at
          }
        }
      }
    },
    // 送出資料
    async handleSubmit() {
      // Preprocessing
      const args = await this.getUpdateActualCoinArgs()

      // Start submitting
      if (args) {
        this.isLoading = true
        try {
          const {
            updateActualCoin
          } = await this.$operatorGraphqlProvider.updateActualCoin(args)
          infoModal({
            title: this.$t('i18n_update_result'),
            content: updateActualCoin,
            width: 500
          })
        } catch (e) {
          errorModal({
            title: this.$t('i18n_code_500001')
          })
        }
        this.isLoading = false

        // 送出資料後刷新列表
        this.handleCloseModal()
        this.$emit('onReloadList')
      }
    }
  }
}
</script>
